var increment = function($el) {
  var number = parseInt($el.html());
  $el.html(number + 1);
};

var getScreenSize = function() {
  var windowWidth = $(window).width();
  if (windowWidth > 1199) {
    return 'desktop';
  } else if (windowWidth > 979) {
    return 'tablet_landscape';
  } else if (windowWidth > 768) {
    return 'tablet_portrait';
  } else {
    return 'mobile';
  }
};

var determineLeftOffset = function() {
  var $coursePageContent = $('#course-page-content');
  var coursePageContentRight =
    $coursePageContent.offset().left +
    $coursePageContent[0].getBoundingClientRect().width;
  var unassignedContentWidth = $(
    '#unassignedContentArea'
  )[0].getBoundingClientRect().width;
  var coursePageContentPadding = 20;
  var leftOffset =
    coursePageContentRight - unassignedContentWidth - coursePageContentPadding;
  return leftOffset;
};

var ScheduleModule = new JS.Class({
  initialize: function(moduleJSON) {
    var module;
    if (typeof moduleJSON === 'string') {
      // assume it is a json string
      module = JSON.parse(moduleJSON);
    } else if (typeof moduleJSON === 'object') {
      module = moduleJSON;
    } else {
      return false;
    }

    this.uiID = module.uiID;
    this.title = module.title;
    this.path = module.path;
    this.url = module.url;
    this.startDate = module.startDate;
    this.endDate = module.endDate;
    this.content = module.content;
    this.summary = module.summary;
    this.activityCategories = module.activityCategories;
  },

  addContent: function(content, pos) {
    if (pos == undefined) {
      pos = this.content.length;
    }
    this.content = [].concat(
      this.content.slice(0, pos),
      [content],
      this.content.slice(pos, this.content.length)
    );
  },

  addActivity: function(activity, activityCategory, pos) {
    // Assume activity category exists.
    if (pos == undefined) {
      pos = this.activityCategories[activityCategory].activities.length;
    }
    this.activityCategories[activityCategory].activities = [].concat(
      this.activityCategories[activityCategory].activities.slice(0, pos),
      [activity],
      this.activityCategories[activityCategory].activities.slice(
        pos,
        this.activityCategories[activityCategory].activities.length
      )
    );
  },

  addActivityCategory: function(activityCategory, pos) {
    if (pos == undefined) {
      pos = this.activities.length;
    }
    this.activityCategories = [].concat(
      this.activityCategories.slice(0, pos),
      [activityCategory],
      this.activityCategories.slice(pos, this.activityCategories.length)
    );
  },

  toJSON: function() {
    return {
      title: this.title,
      path: this.path,
      url: this.url,
      uiID: this.uiID,
      startDate: this.startDate,
      endDate: this.endDate,
      content: this.content,
      summary: this.summary,
      activityCategories: this.activityCategories,
      deletedContent: this.deletedContent,
    };
  },
});

var UISchedule = new JS.Class({
  /*
		Example Data:

		'cohort': {
			'title': 'First Cohort',
			'path': 'courses/STARCRAFT101/Cohorts/FirstCohort',
			'url': 'http://localhost:8000/courses/STARCRAFT101/Cohorts/FirstCohort',
			'startDate': '2012-10-11T00:00:00',
			'unassignedContent': [{
				'type': 'video',
				'title': 'My Video 3',
				'url': 'http://youtube.com/watch?v=someVideo3',
				'provider': 'YouTube',
				'path': 'courses/STARCRAFT101/Videos/SomeVideo3',
				'url': 'http://localhost:8000/courses/STARCRAFT101/Pages/MyPage3'
			}, {
				'type': 'media',
				'title': 'My Media 2',
				'path': 'courses/STARCRAFT101/Media/MyMedia2',
				'url': 'http://localhost:8000/courses/STARCRAFT101/Media/MyMedia2'
			}, {
				'type': 'media',
				'title': 'My Media 3',
				'path': 'courses/STARCRAFT101/Media/MyMedia3',
				'url': 'http://localhost:8000/courses/STARCRAFT101/Media/MyMedia3'
			}],
			'unassignedActivities': [{
				'title': 'My Activity 3',
				'path': 'courses/STARCRAFT101/Activities/MyActivity3',
				'url': 'http://localhost:8000/courses/STARCRAFT101/Activities/MyActivity3',
				'startDate': '2012-10-11T00:00:00',
				'endDate': '2012-10-11T00:00:00'
			}, {
				'title': 'My Activity 4',
				'path': 'courses/STARCRAFT101/Activities/MyActivity4',
				'url': 'http://localhost:8000/courses/STARCRAFT101/Activities/MyActivity4',
				'startDate': '2012-10-11T00:00:00',
				'endDate': '2012-10-11T00:00:00'
			}],
			'deletedContent': [{
				'title': 'Deleted content',
				'type': 'activity',
				'path': 'courses/STARCRAFT101/Activities/DeletedContent',
				'url': 'http://localhost:8000/courses/STARCRAFT101/Activities/DeletedContent'
			}],
			'modules': [{
				'title': 'First Module',
				'path': 'courses/STARCRAFT101/Modules/FirstModule',
				'url': 'http://localhost:8000/courses/STARCRAFT101/Modules/FirstModule',
				'startDate': '2012-10-11T00:00:00',
				'endDate': '2012-10-11T00:00:00',
				'summary': 'This is the first module of the starcraft course. Hello.',
				'content': [{
					'type': 'video',
					'title': 'My Video 1',
					'url': 'http://youtube.com/watch?v=someVideo',
					'provider': 'YouTube',
					'path': 'courses/STARCRAFT101/Videos/SomeVideo',
					'url': 'http://localhost:8000/courses/STARCRAFT101/Videos/MyVideo1'
				}, {
					'type': 'video',
					'title': 'My Video 2',
					'url': 'http://youtube.com/watch?v=someVideo2',
					'provider': 'YouTube',
					'path': 'courses/STARCRAFT101/Videos/SomeVideo2',
					'url': 'http://localhost:8000/courses/STARCRAFT101/Videos/MyVideo2'
				}, {
					'type': 'page',
					'title': 'My Page 1',
					'path': 'courses/STARCRAFT101/Media/MyPage1',
					'url': 'http://localhost:8000/courses/STARCRAFT101/Pages/MyPage1'
				}, {
					'type': 'page',
					'title': 'My Page 2',
					'path': 'courses/STARCRAFT101/Media/MyPage2',
					'url': 'http://localhost:8000/courses/STARCRAFT101/Pages/MyPage2'
				}, {
					'type': 'media',
					'title': 'My Media 1',
					'path': 'courses/STARCRAFT101/Media/MyMedia1',
					'url': 'http://localhost:8000/courses/STARCRAFT101/Media/MyMedia1'
				}],

				'activityCategories': [{
					'title': 'Activities',
					'affectsProgress': true,
					'activities': [{
						'title': 'My Activity 1',
						'path': 'courses/STARCRAFT101/Activities/MyActivity1',
						'url': 'http://localhost:8000/courses/STARCRAFT101/Activities/MyActivity1',
						'startDate': '2012-10-11T00:00:00',
						'endDate': '2012-10-11T00:00:00'
					}, {
						'title': 'My Activity 2',
						'path': 'courses/STARCRAFT101/Activities/MyActivity2',
						'url': 'http://localhost:8000/courses/STARCRAFT101/Activities/MyActivity2',
						'startDate': '2012-10-11T00:00:00',
						'endDate': '2012-10-11T00:00:00'
					}]
				}]
			}]
		}
	 */
  constants: {},
  cohortDateFormat: '%d %b %Y %H:%M',
  activityDateFormat: '%d %b %Y %H:%M',
  moduleDateFormat: '%d %b %Y %H:%M',
  emptySummaryText:
    '<span class="emptySummaryText">(click to edit summary)</span>',
  states: {
    LOADING: -1, // Schedule is being loaded
    RENDERING: 1, // Visual elements are being generated
    NORMAL: 2, // Default State
    SUMMARY_EDIT: 3, // A summary is being edited
    REARRANGE_MODULES: 4, // Modules are being rearranged
  },
  initialize: function(scheduleJSON, constants) {
    var schedule = this;
    this.changeState(this.states.LOADING);

    this.$window = $(window);
    this.$scheduleLoader = $('#scheduleLoader');
    this.$scheduleArea = $('#scheduleArea');
    this.$scheduleOptions = $('#scheduleOptions');
    this.$scheduleContent = $('#scheduleContent');
    this.$moduleList = $('#moduleList');
    this.$moduleActivityCategories = $('#moduleActivityCategories');
    this.$pageAccordionList = $('#pageAccordionList');
    this.$mediaAccordionList = $('#mediaAccordionList');
    this.$videoAccordionList = $('#videoAccordionList');
    this.$activityAccordionList = $('#activityAccordionList');
    this.$numUnassignedPages = $('#numUnassignedPages');
    this.$numUnassignedMedia = $('#numUnassignedMedia');
    this.$numUnassignedVideos = $('#numUnassignedVideos');
    this.$numUnassignedActivities = $('#numUnassignedActivities');
    this.$unassignedContentArea = $('#unassignedContentArea');
    this.$trashCan = $('#trashCan');
    this.$trashCanTotal = $('#trashCanTotal');
    this.$removeDatesButton = $('#removeDates');
    this.$recalculateDatesButton = $('#recalculateDates');
    this.$noCohortDatesMessage = $('#noCohortDatesMessage');
    this.$recalculateDatesRow = $('#recalculateDatesRow');
    this.$removeDatesRow = $('#removeDatesRow');
    this.$timezone = $('#timezone');
    this.$cohortStartDate = $('#cohortStartDate');
    this.$pageEditorModal = $('#pageEditorModal');
    this.$pageEditorPageLink = $('#pageEditorPageLink');
    this.$pageEditorIFrame = $('#pageEditorIFrame');
    this.$pageEditorLoadingMessage = $('#pageEditorLoadingMessage');
    this.$firstModuleMessage = $('#firstModuleMessage');

    this.uiIDCount = 0;
    this.uiIDHash = {};
    this.constants = constants;
    this.modules = [];

    // set up ckeditor options
    CKEDITOR.disableAutoInline = true;
    this.ckeditorOptions = {
      extraPlugins: 'autogrow,hoverlink',
      removePlugins:
        'about,pastetext,pastefromword,undo,clipboard,specialchar,stylescombo,paragraph,tabletools,table,maximize,scayt,horizontalrule,format,wsc,elementspath',
      removeButtons:
        'Strike,Subscript,Superscript,Anchor,Indent,Outdent,Blockquote',
      resize_enabled: false, // remove the bottom bar completely
      autoGrow_minHeight: '150',
      autoGrow_onStartup: true,
      toolbarGroups: [
        { name: 'basicstyles', groups: ['basicstyles'] },
        { name: 'list', groups: ['list'] },
        { name: 'links', groups: ['links'] },
        { name: 'insert', groups: ['insert'] },
        { name: 'document', groups: ['mode'] },
      ],
      fullPage: false,
      SITE_URL: constants.SITE_URL,
      MEDIA_URL: constants.MEDIA_URL,
    };

    this.loadAndRefresh(true);
    this.changeState(this.states.NORMAL);
  },
  setUIID: function($element, optionalID) {
    if (!($element instanceof jQuery)) {
      if ($element instanceof HTMLElement) {
        $element = $($element);
      }
    }

    var uiID;
    if (optionalID) {
      uiID = optionalID;
    } else {
      uiID = this.uiIDCount;
      this.uiIDCount += 1;
    }
    $element.attr('data-ui-id', uiID);
    this.uiIDHash[uiID] = $element;
  },
  getElementByUIID: function(uiID) {
    return this.uiIDHash[uiID];
  },
  getNextUIID: function() {
    return this.uiIDCount++;
  },
  loadAndRefresh: function(initialLoad) {
    var schedule = this;

    function temporaryModuleDataConverter(moduleData) {
      var convertedModuleData = [];
      for (var i = 0; i < moduleData.length; i++) {
        var module = moduleData[i];
        var convertedModule = {
          title: module.name,
          path: module.link,
          url: this.constants.SITE_URL + '/' + module.link,
          startDate: module.startDate,
          endDate: module.endDate,
        };

        var convertedContentList = [];
        for (var j = 0; j < module.content.length; j++) {
          var content = module.content[j];
          var convertedContent = {
            type: content.type,
            title: content.title,
            path: content.path,
            url: content.url,
            thumbnail: content.thumbnail,
            affectsProgress: content.affectsProgress,
          };

          convertedContentList[convertedContentList.length] = convertedContent;
        }

        var convertedActivityCategories = [];

        // Because we haven't modified the back-end, we only have two types of categories. Core and Extra.
        // Later, when we migrate, we will have n categories, each of which will be responsible for determoining
        // whether the category contributes to progress or not.

        var coreActivityCategory = {
          title: schedule.getCoreActivitiesTitle(),
          affectsProgress: true,
        };
        var coreActivities = [];
        for (
          var j = 0;
          j < module.activityListing.core[0].activities.length;
          j++
        ) {
          var activity = module.activityListing.core[0].activities[j];

          // Activities don't actually require a conversion (yay!)
          var convertedCoreActivity = activity;
          coreActivities[coreActivities.length] = convertedCoreActivity;
        }
        coreActivityCategory['activities'] = coreActivities;

        var extraActivityCategory = {
          title: schedule.getExtraActivitiesTitle(),
          affectsProgress: false,
        };
        var extraActivities = [];
        for (
          var j = 0;
          j < module.activityListing.extra[0].activities.length;
          j++
        ) {
          var activity = module.activityListing.extra[0].activities[j];
          var convertedExtraActivity = activity;
          extraActivities[extraActivities.length] = convertedExtraActivity;
        }
        extraActivityCategory['activities'] = extraActivities;

        convertedActivityCategories[
          convertedActivityCategories.length
        ] = coreActivityCategory;
        convertedActivityCategories[
          convertedActivityCategories.length
        ] = extraActivityCategory;

        convertedModule['content'] = convertedContentList;
        convertedModule['activityCategories'] = convertedActivityCategories;

        convertedModule['summary'] = module.summary;

        convertedModuleData[convertedModuleData.length] = convertedModule;
      }

      return { modules: convertedModuleData };
    }

    API.get('courses/' + schedule.constants.COURSE_PATH + '/EditingContent', {
      cohort: schedule.constants.COHORT_PATH,
    })
      .done(function(res) {
        var moduleData = JSON.parse(res.moduleData);
        var scheduleJSON = {
          cohort: {
            title: res.title,
            path: schedule.constants.COHORT_PATH,
            url: schedule.constants.SITE_URL + schedule.constants.COHORT_PATH,
            startDate: res.startDate,
            coreActivitiesTitle: res.coreActivitiesTitle,
            extraActivitiesTitle: res.extraActivitiesTitle,
          },
        };

        $.extend(
          scheduleJSON['cohort'],
          temporaryModuleDataConverter.call(schedule, moduleData)
        );

        var unassignedActivityData = JSON.parse(res.unassignedActivities);
        $.extend(scheduleJSON['cohort'], {
          unassignedActivities: unassignedActivityData,
        });

        var unassignedContentData = JSON.parse(res.unassignedContent);
        $.extend(scheduleJSON['cohort'], {
          unassignedContent: unassignedContentData,
        });

        schedule.fromJSON(scheduleJSON);

        if (!schedule.staticEventsSet) {
          schedule.setStaticEventHandlers();
          schedule.setAllUIIDs();
        }
        schedule.staticEventsSet = true;
        CourseContentWidget.apply('#manageCourseContentButton', {
          constants: { MEDIA_URL: schedule.constants.MEDIA_URL },
        });

        if (initialLoad) {
          schedule.initialJSON = {};

          // do a deep copy of the json
          $.extend(true, schedule.initialJSON, schedule.toJSON());
        }

        schedule.$scheduleLoader.fadeOut(500, function() {
          schedule.$scheduleContent.fadeIn(500);
          schedule.render();
        });
      })
      .fail(function(res) {
        alert(
          'There was a problem loading the data for the schedule editor. Please try again later.'
        );
      });
  },

  addModule: function(module, pos) {
    if (pos == undefined) {
      pos = this.modules.length;
    }
    this.modules = [].concat(
      this.modules.slice(0, pos),
      [module],
      this.modules.slice(pos, this.modules.length)
    );
  },

  getModules: function() {
    return this.modules;
  },

  fromJSON: function(scheduleJSON) {
    var schedule;
    if (typeof scheduleJSON === 'string') {
      // assume it is a json string
      schedule = JSON.parse(scheduleJSON).cohort;
    } else if (typeof scheduleJSON === 'object') {
      if (scheduleJSON.cohort) {
        schedule = scheduleJSON.cohort;
      } else {
        schedule = scheduleJSON;
      }
    } else {
      return false;
    }

    this.title = schedule.title;
    this.path = schedule.path;
    this.url = schedule.url;
    this.startDate = schedule.startDate;
    this.modules =
      $.map(schedule.modules, function(module) {
        return new ScheduleModule(module);
      }) || [];
    this.unassignedContent = schedule.unassignedContent || [];
    this.unassignedActivities = schedule.unassignedActivities || [];
    this.deletedContent = schedule.deletedContent || [];
    this.coreActivitiesTitle = schedule.coreActivitiesTitle;
    this.extraActivitiesTitle = schedule.extraActivitiesTitle;
  },
  toJSON: function() {
    var modules = this.getModules();
    var scheduleJSON = {
      title: this.title,
      path: this.path,
      url: this.url,
      startDate: this.startDate,
      modules: $.map(modules, function(module) {
        return module.toJSON();
      }),
      unassignedContent: this.unassignedContent,
      unassignedActivities: this.unassignedActivities,
      deletedContent: this.deletedContent,
      coreActivitiesTitle: this.coreActivitiesTitle,
      extraActivitiesTitle: this.extraActivitiesTitle,
    };
    return scheduleJSON;
  },

  removeByUIID: function(uiID) {
    var data = this.getByUIID(uiID);
    data.parent.splice(data.index, 1);
  },

  getByUIID: function(uiID) {
    // We can't just return a reference to the object in case we need
    // to splice it. So let's return a JS object containing a reference
    // to the array + the index containing the item as well as the
    // reference to the item.
    var uiID = parseInt(uiID);
    var dataObject = false;
    var unassignedContent = this.unassignedContent;
    var unassignedActivities = this.unassignedActivities;
    var deletedContent = this.deletedContent;

    $.each(unassignedContent, function(k, v) {
      if (this.uiID === uiID) {
        dataObject = {
          ref: unassignedContent[k],
          parent: unassignedContent,
          index: k,
        };

        // nb: return false used inside '.each' acts as a break
        return false;
      }
    });
    $.each(deletedContent, function(k, v) {
      if (this.uiID === uiID) {
        dataObject = {
          ref: deletedContent[k],
          parent: deletedContent,
          index: k,
        };

        // nb: return false used inside '.each' acts as a break
        return false;
      }
    });
    if (!dataObject) {
      $.each(unassignedActivities, function(k, v) {
        if (this.uiID === uiID) {
          dataObject = {
            ref: unassignedActivities[k],
            parent: unassignedActivities,
            index: k,
          };

          return false;
        }
      });
      if (!dataObject) {
        var modules = this.modules;
        $.each(modules, function(k, v) {
          // Check if this module has this UIID
          if (this.uiID === uiID) {
            dataObject = {
              ref: modules[k],
              parent: modules,
              index: k,
            };

            return false;
          }

          var content = this.content;
          $.each(content, function(k, v) {
            // Check if this content has this UIID
            if (this.uiID === uiID) {
              dataObject = {
                ref: content[k],
                parent: content,
                index: k,
              };

              return false;
            }
          });

          if (!dataObject) {
            var activityCategories = this.activityCategories;

            // Sometime in the future we need to check if activity category has this UIID
            $.each(activityCategories, function(k, v) {
              if (this.uiID === uiID) {
                dataObject = {
                  ref: activityCategories[k],
                  parent: activityCategories,
                  index: k,
                };
                return false;
              }

              if (dataObject) return false;

              var activities = this.activities;

              // Check if this activity has this UIID
              $.each(activities, function(k, v) {
                if (this.uiID === uiID) {
                  dataObject = {
                    ref: activities[k],
                    parent: activities,
                    index: k,
                  };

                  return false;
                }
              });

              if (dataObject) return false;
            });
          }

          if (dataObject) return false;
        });
      }
    }

    return dataObject;
  },
  removeContentFromModules: function(uiID) {
    var schedule = this;

    var content = schedule.getByUIID(uiID);

    schedule.removeByUIID(uiID);

    schedule.unassignedContent.push(content.ref);

    schedule.render();
    schedule.updateSubmissionForm();
  },
  deleteItem: function($helper) {
    var schedule = this;

    // Search unassigned content/activities for the page, and then delete it.
    var contentType = $helper.attr('data-type');
    if (contentType == 'activity') {
      var activity = {
        type: contentType,
        title: $helper.attr('data-title'),
        path: $helper.attr('data-path'),
        url: $helper.attr('data-url'),
        startDate: $helper.attr('data-startdate'),
        endDate: $helper.attr('data-enddate'),
        pageIconSmall: $helper.attr('data-pageiconsmall'),
        uiID: parseInt($helper.attr('data-ui-id')),
      };

      schedule.removeUnassignedActivity(activity.uiID);
      schedule.deletedContent.push(activity);
    } else {
      var content = {
        type: contentType,
        title: $helper.attr('data-title'),
        path: $helper.attr('data-path'),
        url: $helper.attr('data-url'),
        thumbnail: $helper.attr('data-thumbnail'),
        affectsProgress: $helper.attr('data-affects-progress') === 'true',
        uiID: parseInt($helper.attr('data-ui-id')),
      };
      schedule.removeUnassignedContent(content.uiID);
      schedule.deletedContent.push(content);
    }

    schedule.render();
    schedule.updateSubmissionForm();
  },
  removeUnassignedContent: function(uiID) {
    this.removeUnassigned(uiID);
  },
  removeUnassignedActivity: function(uiID) {
    this.removeUnassigned(uiID);
  },
  removeUnassigned: function(uiID) {
    if (this.unassignedContent.length) {
      for (var i = 0, len = this.unassignedContent.length; i < len; i++) {
        if (this.unassignedContent[i].uiID == uiID) {
          this.unassignedContent.splice(i, 1);
          break;
        }
      }
    }
    if (this.unassignedActivities.length) {
      for (var i = 0, len = this.unassignedActivities.length; i < len; i++) {
        if (this.unassignedActivities[i].uiID == uiID) {
          this.unassignedActivities.splice(i, 1);
          break;
        }
      }
    }
  },
  move: function($helper, $droppedContainer) {
    var schedule = this;

    // Handle the case when we're dropping something from the schedule back into the unassigned content area.
    if ($droppedContainer.attr('id') === 'unassignedContentArea') {
      // Do the move internally
      var contentType = $helper.attr('data-type');
      if (contentType == 'activity') {
        var activity = {
          type: contentType,
          title: $helper.attr('data-title'),
          path: $helper.attr('data-path'),
          url: $helper.attr('data-url'),
          uiID: parseInt($helper.attr('data-ui-id')),

          // We don't need dates when we return back to the unassigned area
          //'startDate': $helper.attr('data-startdate'),
          //'endDate': $helper.attr('data-enddate'),
          pageIconSmall: $helper.attr('data-pageiconsmall'),
        };

        schedule.removeByUIID(activity.uiID);
        schedule.unassignedActivities.push(activity);
      } else {
        var content = {
          type: contentType,
          title: $helper.attr('data-title'),
          path: $helper.attr('data-path'),
          url: $helper.attr('data-url'),
          uiID: parseInt($helper.attr('data-ui-id')),
          thumbnail: $helper.attr('data-thumbnail'),
          affectsProgress: $helper.attr('data-affects-progress') === 'true',
        };

        schedule.removeByUIID(content.uiID);
        schedule.unassignedContent.push(content);
      }
      schedule.render();
      schedule.updateSubmissionForm();
    } else if ($droppedContainer.hasClass('moduleContentList')) {
      var moduleIndex = $helper.closest('.module').index();

      if (moduleIndex !== -1) {
        var content = {
          type: $helper.attr('data-type'),
          title: $helper.attr('data-title'),
          path: $helper.attr('data-path'),
          url: $helper.attr('data-url'),
          uiID: parseInt($helper.attr('data-ui-id')),
          thumbnail: $helper.attr('data-thumbnail'),
          affectsProgress: $helper.attr('data-affects-progress') === 'true',
        };

        var helperIndex = $helper.index();

        // We remove if we're not dropping in the same place
        schedule.removeByUIID(content.uiID);
        schedule.getModules()[moduleIndex].addContent(content, helperIndex);
        schedule.render();
        schedule.updateSubmissionForm();
      }
    } else if ($droppedContainer.hasClass('moduleActivityList')) {
      var moduleIndex = $helper.closest('.module').index();

      if (moduleIndex !== -1) {
        var activityStartDate = $helper.attr('data-startdate')
          ? $helper.attr('data-startdate')
          : $helper.closest('.module').attr('data-start');
        var activityEndDate = $helper.attr('data-enddate')
          ? $helper.attr('data-enddate')
          : $helper.closest('.module').attr('data-end');
        var activity = {
          type: $helper.attr('data-type'),
          title: $helper.attr('data-title'),
          path: $helper.attr('data-path'),
          url: $helper.attr('data-url'),
          uiID: parseInt($helper.attr('data-ui-id')),
          pageIconSmall: $helper.attr('data-pageiconsmall'),
          startDate: activityStartDate,
          endDate: activityEndDate,
        };

        var helperIndex = $helper.index();
        schedule.removeByUIID(activity.uiID);

        // Determine the activity category based on its position - bad
        // Assume the categories can not be re-arranged.
        var activityCategoryPosition = $helper.closest('div').index();

        schedule
          .getModules()
          [moduleIndex].addActivity(
            activity,
            activityCategoryPosition,
            helperIndex
          );
        schedule.render();
        schedule.updateSubmissionForm();
      }
    }

    // update the form to be submitted after every move? / Alternatively, call toJSON upon click of "Save Changes"
    schedule.updateSubmissionForm();
  },
  updateSubmissionForm: function() {
    var schedule = this;
    $('#scheduleJSON').val(JSON.stringify(schedule.toJSON()));
    this.$window.trigger('scheduleEditorDirty');
  },
  clearSubmissionForm: function() {
    var schedule = this;
    $('#scheduleJSON').removeAttr('value');
    this.$window.trigger('scheduleEditorClean');
  },
  changeState: function(newState) {
    this.state = newState;

    // Handle transitioning between states. Need some more thought here.
    /*
		switch (newState) {
			case this.states.LOADING:
				//debugger;
				this.$scheduleContent.hide();
				this.$scheduleLoader.find('span').hide();
				$('#scheduleLoaderMessage_Initialising').show();
				break;
			case this.states.NORMAL:
				this.$scheduleLoader.find('span').hide();
				this.$scheduleContent.show();
				break;
			case this.states.RENDERING:
				this.$scheduleContent.hide();
				this.$scheduleLoader.find('span').hide();
				$('#scheduleLoaderMessage_Rendering').show();
				break;
			case this.states.SUMMARY_EDIT:
			case this.states.REARRANGE_MODULES:
				break;
		}
		*/
  },
  render: function() {
    var schedule = this;
    this.changeState(this.states.RENDERING);

    $('.accordionList').empty();
    schedule.$numUnassignedVideos.html('0');
    schedule.$numUnassignedPages.html('0');
    schedule.$numUnassignedMedia.html('0');
    schedule.$numUnassignedActivities.html('0');

    // Prepare to re-assign all UI IDs
    schedule.uiIDHash = {};

    // Display the schedule onto the edit area
    var scheduleJSON = this.toJSON();

    // Hide all the placeholder text
    $('.emptyModuleContentList, .emptyModuleActivityList').hide();

    var $moduleList = $('<ul>');
    $.each(scheduleJSON.modules, function() {
      var $moduleHtml;

      var moduleTemplateData = {
        title: this.title,
        path: this.path,
        url: this.url,
        summary: this.summary,
        uiID: parseInt(this.uiID),
      };

      if (this.startDate) {
        $.extend(moduleTemplateData, {
          startDate: this.startDate,
          endDate: this.endDate,
          startDateProcessed: Utilities.formatTimestamp(
            this.startDate,
            schedule.moduleDateFormat
          ),
          endDateProcessed: Utilities.formatTimestamp(
            this.endDate,
            schedule.moduleDateFormat
          ),
        });
      } else {
        $.extend(moduleTemplateData, {
          hideDates: true,
        });
      }

      dust.render('scheduleEditorModule', moduleTemplateData, function(
        moduleError,
        moduleHtml
      ) {
        $moduleHtml = $(moduleHtml);
        if ($moduleHtml.find('.moduleSummary').html() == '') {
          $moduleHtml
            .find('.moduleSummary')
            .attr('data-empty', '1')
            .html(schedule.emptySummaryText);
        } else {
          $moduleHtml.find('.moduleSummary').attr('data-empty', '0');
        }
      });

      var scheduleContent = this.content;
      var $moduleContent = $moduleHtml.find('.moduleContentList');
      if (scheduleContent && scheduleContent.length) {
        $.each(scheduleContent, function() {
          var contentTemplateData = this;
          switch (this.type) {
            case 'video':
              contentTemplateData.thumbnailClass = 'contentVideo';
              contentTemplateData.pageTypeTitle = 'Media';
              break;
            case 'page':
              contentTemplateData.thumbnailClass = 'contentOther';
              contentTemplateData.pageTypeTitle = 'Wiki Pages';
              break;
            case 'media':
              contentTemplateData.thumbnailClass = 'contentOther';
              contentTemplateData.pageTypeTitle = 'Media';
              break;
          }

          dust.render(
            'scheduleEditorContentItem',
            contentTemplateData,
            function(pageError, pageHtml) {
              var $pageHtml = $(pageHtml);
              $moduleContent.append($pageHtml);
              schedule.uiIDHash[contentTemplateData.uiID] = {
                $element: $pageHtml,
              };
              $pageHtml
                .find('.scheduleEditor-removeFromModule')
                .on('click', function() {
                  schedule.removeContentFromModules(contentTemplateData.uiID);
                });
            }
          );
        });
      } else {
        $moduleContent.siblings('.emptyModuleContentList').show();
      }

      var scheduleActivityCategories = this.activityCategories;
      var $moduleActivityCategories = $moduleHtml
        .find('.moduleActivityCategories')
        .empty();

      if (scheduleActivityCategories) {
        $.each(scheduleActivityCategories, function() {
          var activityCategoryTemplateData = this;

          if (activityCategoryTemplateData['affectsProgress']) {
            activityCategoryTemplateData[
              'title'
            ] = schedule.getCoreActivitiesTitle();
          } else {
            activityCategoryTemplateData[
              'title'
            ] = schedule.getExtraActivitiesTitle();
          }

          var $activityCategory;

          dust.render(
            'activityCategory',
            activityCategoryTemplateData,
            function(error, html) {
              $activityCategory = $('<div>').html(html);
              //debugger;
              $activityCategory.find('.moduleActivityTitle').tooltip({
                title: function() {
                  if ($(this).attr('data-affects-progress') + '' === 'true') {
                    return 'These activities contribute towards course progress';
                  }
                  return 'These activities do not contribute towards course progress';
                },
              });
            }
          );

          var $activityList = $activityCategory
            .find('.moduleActivityList')
            .empty();

          if (this.activities && this.activities.length) {
            $.each(this.activities, function() {
              var activityTemplateData = this;
              if (activityTemplateData['startDate']) {
                activityTemplateData['showDates'] = true;
                activityTemplateData[
                  'startDateProcessed'
                ] = Utilities.formatTimestamp(
                  activityTemplateData['startDate'],
                  schedule.activityDateFormat
                );
                activityTemplateData[
                  'endDateProcessed'
                ] = Utilities.formatTimestamp(
                  activityTemplateData['endDate'],
                  schedule.activityDateFormat
                );
              } else {
                activityTemplateData['showDates'] = false;
              }

              var $activity;
              dust.render('activity', activityTemplateData, function(
                error,
                html
              ) {
                $activity = $(html);
                schedule.uiIDHash[activityTemplateData.uiID] = {
                  $element: $activity,
                };
              });
              $activityList.append($activity);
            });
          } else {
            $activityCategory.find('.emptyModuleActivityList').show();
          }

          $moduleActivityCategories.append($activityCategory);
        });
      }

      $moduleList.append($moduleHtml);
    });
    schedule.$moduleList.html($moduleList.contents());

    // Set vars we need for unassigned content
    if (scheduleJSON.unassignedContent) {
      $.each(scheduleJSON.unassignedContent, function() {
        var title = this.title || this.path;
        var path = this.path;
        var url = this.url;
        var type = this.type;
        var uiID = this.uiID;
        var thumbnail = this.thumbnail;
        var affectsProgress = this.affectsProgress;

        var $trashHover = $(
          '<span class="returnMessage"><div><i class="icon icon-remove"></i></div>Delete </span>'
        );
        switch (this.type) {
          case 'page':
            var $unassignedPageItem = $('<li>')
              .attr({
                class: 'accordionListItem',
                'data-ui-id': uiID,
                'data-type': 'page',
                'data-title': title,
                'data-path': path,
                'data-url': url,
                'data-type': type,
                'data-thumbnail': thumbnail,
                'data-affects-progress': affectsProgress,
              })
              .append(
                $('<a>')
                  .attr({ href: url, target: '_blank' })
                  .text(title)
              );
            $unassignedPageItem.prepend($trashHover);
            schedule.uiIDHash[uiID] = { $element: $unassignedPageItem };
            schedule.$pageAccordionList.append($unassignedPageItem);
            increment(schedule.$numUnassignedPages);
            break;
          case 'media':
            var $unassignedMediaItem = $('<li>')
              .attr({
                class: 'accordionListItem',
                'data-ui-id': uiID,
                'data-type': 'media',
                'data-title': title,
                'data-path': path,
                'data-url': url,
                'data-type': type,
                'data-thumbnail': thumbnail,
                'data-affects-progress': affectsProgress,
              })
              .append(
                $('<a>')
                  .attr({ href: url, target: '_blank' })
                  .text(title)
              );
            $unassignedMediaItem.prepend($trashHover);
            schedule.uiIDHash[uiID] = { $element: $unassignedMediaItem };
            schedule.$mediaAccordionList.append($unassignedMediaItem);
            increment(schedule.$numUnassignedMedia);
            break;
          case 'video':
            var $unassignedVideoItem = $('<li>')
              .attr({
                class: 'accordionListItem',
                'data-ui-id': uiID,
                'data-type': 'video',
                'data-title': title,
                'data-path': path,
                'data-url': url,
                'data-type': type,
                'data-thumbnail': thumbnail,
                'data-affects-progress': affectsProgress,
              })
              .append(
                $('<a>')
                  .attr({ href: url, target: '_blank' })
                  .text(title)
              );
            $unassignedVideoItem.prepend($trashHover);
            schedule.uiIDHash[uiID] = { $element: $unassignedVideoItem };

            // now into mediaAccordionList, not videoAccordionList
            schedule.$mediaAccordionList.append($unassignedVideoItem);
            increment(schedule.$numUnassignedMedia);
            break;
        }
      });
    }

    if (scheduleJSON.unassignedActivities) {
      $.each(scheduleJSON.unassignedActivities, function() {
        var $trashHover = $(
          '<span class="returnMessage"><div><i class="icon icon-remove"></i></div>Delete </span>'
        );
        var title = this.title || this.path;
        var path = this.path;
        var url = this.url;
        var startDate = this.startDate;
        var endDate = this.endDate;
        var pageIconSmall = this.pageIconSmall;
        var uiID = this.uiID;

        var unassignedActivityAttributes = {
          class: 'accordionListItem',
          'data-ui-id': uiID,
          'data-type': 'activity',
          'data-title': title,
          'data-path': path,
          'data-url': url,
          'data-pageiconsmall': pageIconSmall,
        };

        if (startDate) {
          $.extend(unassignedActivityAttributes, {
            'data-startdate': startDate,
            'data-enddate': endDate,
          });
        }

        var $unassignedActivityItem = $('<li>')
          .attr(unassignedActivityAttributes)
          .append(
            $('<a>')
              .attr({ href: url, target: '_blank' })
              .text(title)
          );
        $unassignedActivityItem.prepend($trashHover);
        schedule.uiIDHash[uiID] = { $element: $unassignedActivityItem };
        schedule.$activityAccordionList.append($unassignedActivityItem);
        increment(schedule.$numUnassignedActivities);
      });
    }

    if (schedule.startDate) {
      schedule.$noCohortDatesMessage.hide();
      schedule.$recalculateDatesRow.show();
      schedule.$removeDatesRow.show();
    } else {
      schedule.$noCohortDatesMessage.show();
      schedule.$recalculateDatesRow.hide();
      schedule.$removeDatesRow.hide();
    }

    schedule.$timezone.text(schedule.constants.TIMEZONE);
    if (scheduleJSON.startDate) {
      schedule.$cohortStartDate
        .attr('data-value', scheduleJSON.startDate)
        .val(
          Utilities.formatTimestamp(
            scheduleJSON.startDate,
            schedule.cohortDateFormat
          )
        );
    }

    // warning: this gets called multiple times. *hopefully* datetimepicker is smart enough not to attach multiple times.
    $('#cohortStartDate')
      .datetimepicker()
      .on('changeDate hide', function(e) {
        var $input = $(e.currentTarget);
        $input.val(
          Utilities.formatTimestamp(e.date, schedule.activityDateFormat)
        );
        $input.attr('data-value', e.date.toISOString());
      });

    if (schedule.$moduleList.find('li.module').length) {
      schedule.$firstModuleMessage.hide();
    } else {
      schedule.$firstModuleMessage.show();
    }

    schedule.fixScrollbar();
    schedule.refreshTrash();
    schedule.setEventHandlers();
    schedule.changeState(schedule.states.NORMAL);
  },

  fixScrollbar: function() {
    var schedule = this;

    // Sometimes the scrollbar appears on the right. This occurs because there's
    // a height discrepancy between the left and right section of the page. Align it
    // here.
    schedule.$scheduleArea.css('min-height', '');
    var scheduleAreaHeight = schedule.$scheduleArea.height(); // left side
    var unassignedContentAreaHeight = schedule.$unassignedContentArea.height(); // right side
    var maxHeight = Math.max(scheduleAreaHeight, unassignedContentAreaHeight);

    schedule.$scheduleArea.css('min-height', maxHeight + 20);
  },
  refreshTrash: function() {
    var self = this;

    self.$trashCanTotal.html('0');
    if (self.deletedContent.length) {
      self.$trashCanTotal.html(self.deletedContent.length);
    }

    // Refresh Trash Can Contents
    var trashContents = self.deletedContent;
    if (trashContents.length) {
      $('#trashInfo').hide();
      var $trashContentTable = $('<table id="trashContentTable"></table>');
      var $tbody = $('<tbody>').appendTo($trashContentTable);

      for (var i = 0, len = trashContents.length; i < len; i++) {
        var trashDetails = trashContents[i];
        trashDetails['typeCapped'] =
          trashDetails['type'].substr(0, 1).toUpperCase() +
          trashDetails['type'].substr(1);
        dust.render('trashItem', trashDetails, function(error, html) {
          $tbody.append(html);
        });
      }
      $('#trashContentTable').replaceWith($trashContentTable);
    } else {
      $('#trashContentTable').html('');
      $('#trashInfo').show();
    }
  },

  moveModule: function(uiID, movedPosition) {
    var schedule = this;

    // uiID - the ui id of the element being moved
    // the position of the new element inside the module array
    var tmpModule;
    for (var i = 0, len = schedule.modules.length; i < len; i++) {
      if (schedule.modules[i].uiID === uiID) {
        tmpModule = schedule.modules.splice(i, 1);
        break;
      }
    }

    if (tmpModule) {
      schedule.modules.splice(movedPosition, 0, tmpModule[0]);
    }
  },
  eventHandlers: {
    /*
		submitAddNewActivityForm: function(e, self) {
			var $formInput = $('#addActivityForm :input');
			var formData = $formInput.serialize();
			API.post('courses/'+self.constants.COURSE_PATH+'/Activities', formData).done(function(res) {
				//self.loadAndRefresh();
				res.createdPage.uiID = self.getNextUIID();
				self.unassignedActivities.unshift(res.createdPage);
				self.initialJSON.unassignedActivities.unshift(res.createdPage);
				self.render();
				$formInput.val('');
			}).fail(function(res) {
				alert(res);
			});
		},
		submitAddNewPageForm: function(e, self) {
			var $formInput = $('#addPageForm :input');
			var formData = $formInput.serialize();
			API.post('courses/'+self.constants.COURSE_PATH+'/Pages', formData).done(function(res) {
				//self.loadAndRefresh();
				res.createdPage.uiID = self.getNextUIID();
				self.unassignedContent.unshift(res.createdPage);
				self.initialJSON.unassignedContent.unshift(res.createdPage);
				self.render();
				$formInput.val('');
			}).fail(function(res) {
				alert(res);
			});
		},
		submitAddNewMediaForm: function(e, self) {
			var $formInput = $('#addMediaForm :input');
			var formData = $formInput.serialize();
			API.post('courses/'+self.constants.COURSE_PATH+'/Media', formData).done(function(res) {
				//self.loadAndRefresh();
				res.createdPage.uiID = self.getNextUIID();
				self.unassignedContent.unshift(res.createdPage);
				self.initialJSON.unassignedContent.unshift(res.createdPage);
				self.render();
				$formInput.val('');
			}).fail(function(res) {
				alert(res);
			});
		},
		submitAddNewVideoForm: function(e, self) {
			var $formInput = $('#addVideoForm :input');
			var formData = $formInput.serialize();
			API.post('courses/'+self.constants.COURSE_PATH+'/Videos', formData).done(function(res) {
				//self.loadAndRefresh();
				res.createdPage.uiID = self.getNextUIID();
				self.unassignedContent.unshift(res.createdPage);
				self.initialJSON.unassignedContent.unshift(res.createdPage);
				self.render();
				$formInput.val('');
			}).fail(function(res) {
				alert(res);
			})
		},
		*/
    showAddNewContentModal: function(e, self) {
      var moduleIndex, moduleTitle;
      var moduleObject = self.getByUIID(
        $(this)
          .closest('.module')
          .attr('data-ui-id')
      );
      var $contentModal = $('#addNewContentModal');
      if (moduleObject) {
        moduleIndex = parseInt(moduleObject['index']);
        moduleTitle = moduleObject.ref.title;

        $('#addNewContentModuleTitle').html(moduleTitle);
        $contentModal
          .attr('data-module', moduleIndex)
          .find('.module-section')
          .show();
      } else {
        $contentModal
          .removeAttr('data-module')
          .find('.module-section')
          .hide();
      }

      $contentModal.find('#content-title-input').removeClass('invalid');
      $contentModal.find('#select-content-label').removeClass('invalid');
      $contentModal
        .find('#assistance-arrow')
        .hide()
        .css({ left: '10px' });
      $contentModal.modal('show');
    },

    showAddNewActivityModal: function(e, self) {
      var $this = $(this);

      var $activityModal = $('#addNewActivityModal');
      var moduleObject = self.getByUIID(
        $(this)
          .closest('.module')
          .attr('data-ui-id')
      );
      if (moduleObject) {
        var moduleActivityList = self.getByUIID(
          $this.prev('.moduleActivityList').attr('data-ui-id')
        );
        var currentUIID = moduleActivityList && moduleActivityList.ref.uiID;
        var moduleIndex = parseInt(moduleObject['index']);
        var moduleTitle = moduleObject.ref.title;
        var activityCategories = (function() {
          var activityCategories = [];
          var moduleActivityCategories =
            self.modules[moduleIndex].activityCategories;
          var numActivityCategories = moduleActivityCategories.length;
          for (var i = 0; i < numActivityCategories; i++) {
            activityCategories.push({
              title: moduleActivityCategories[i].title,
              selected: moduleActivityCategories[i].uiID === currentUIID,
              affectsProgress: moduleActivityCategories[i].affectsProgress,
            });
          }
          return activityCategories;
        })();

        var activityCategoriesHtml = $.map(activityCategories, function(
          element,
          index
        ) {
          return (
            '<option value="' +
            index +
            '"' +
            (element.selected ? 'selected' : '') +
            '>' +
            element.title +
            ' (' +
            (element.affectsProgress ? 'affects' : 'does not affect') +
            ' progress)</option>'
          );
        });

        $('#addNewActivityCategory')
          .empty()
          .append(activityCategoriesHtml);
        $('#addNewActivityModuleTitle').html(moduleTitle);
        $activityModal
          .attr('data-module', moduleIndex)
          .find('.module-section')
          .show();
      } else {
        $activityModal
          .removeAttr('data-module')
          .find('.module-section')
          .hide();
      }

      $activityModal.modal('show');
      $activityModal.find('#activity-title-input').removeClass('invalid');
    },
  },
  setAllUIIDs: function() {
    var schedule = this;
    // This should only be executed once.
    var modules = schedule.getModules();
    for (var i = 0, moduleLength = modules.length; i < moduleLength; i++) {
      var module = modules[i];
      module.uiID = schedule.getNextUIID();
      for (
        var j = 0, contentLength = module.content.length;
        j < contentLength;
        j++
      ) {
        module.content[j].uiID = schedule.getNextUIID();
      }

      for (
        var j = 0, activityCategoryLength = module.activityCategories.length;
        j < activityCategoryLength;
        j++
      ) {
        var activityCategory = module.activityCategories[j];
        activityCategory.uiID = schedule.getNextUIID();
        for (
          var k = 0, activitiesLength = activityCategory.activities.length;
          k < activitiesLength;
          k++
        ) {
          activityCategory.activities[k].uiID = schedule.getNextUIID();
        }
      }
    }

    for (
      var i = 0, unassignedContentLength = schedule.unassignedContent.length;
      i < unassignedContentLength;
      i++
    ) {
      schedule.unassignedContent[i].uiID = schedule.getNextUIID();
    }

    for (
      var i = 0,
        unassignedActivitiesLength = schedule.unassignedActivities.length;
      i < unassignedActivitiesLength;
      i++
    ) {
      schedule.unassignedActivities[i].uiID = schedule.getNextUIID();
    }
  },
  resetAddNewContentModal: function() {
    $('#addNewContentModal input[type=text]').val('');
    $('#addNewContentType > li.highlight').removeClass('highlight');
    $('.addNewContentDetails').hide();
    $('.addNewContentDetails[data-id=file] button').text('Select File');
    $('#currentMediaFileUploaded').text('(none)');
  },
  resetAddNewActivityModal: function() {
    $('#addNewActivityModal input[type=text]').val('');
  },
  setStaticEventHandlers: function() {
    var schedule = this;

    schedule.$window.on('scroll resize', schedule.refreshSidebar);
    schedule.$window.on(
      'resize',
      { schedule: schedule },
      schedule.resizeModals
    );

    // Do toggling magic for the right side of the unassigned content accordion thingos
    $('.addContentButton').click(function() {
      var $this = $(this);
      var state = $this.attr('data-state');

      var deferred = $.Deferred();
      if (state === 'closed') {
        $this.attr('data-state', 'open');
        $this
          .closest('.accordion-group')
          .find('.addContentBox')
          .show(100, function() {
            deferred.resolve();
          });
        $this
          .find('.icon-plus')
          .removeClass('icon-plus')
          .addClass('icon-minus');
        $this.siblings('.accordion-toggle').trigger('click');
      } else {
        // Assume state === 'open'
        $this.attr('data-state', 'closed');
        $this
          .closest('.accordion-group')
          .find('.addContentBox')
          .hide(100, function() {
            deferred.resolve();
          });
        $this
          .find('.icon-minus')
          .removeClass('icon-minus')
          .addClass('icon-plus');
        $this.siblings('.accordion-toggle').trigger('click');
      }

      deferred.done(schedule.refreshSidebar);
    });

    // Give the add new content forms some functionality!
    $('#addActivityForm input').keyup(function(e) {
      var ENTER_KEY = 13;
      if (e.which === ENTER_KEY) {
        schedule.eventHandlers.submitAddNewActivityForm.call(this, e, schedule);
      }
    });

    $('#addPageForm input').keyup(function(e) {
      var ENTER_KEY = 13;
      if (e.which === ENTER_KEY) {
        schedule.eventHandlers.submitAddNewPageForm.call(this, e, schedule);
      }
    });

    $('#addMediaForm input').keyup(function(e) {
      var ENTER_KEY = 13;
      if (e.which === ENTER_KEY) {
        schedule.eventHandlers.submitAddNewMediaForm.call(this, e, schedule);
      }
    });

    $('#addVideoForm input').keyup(function(e) {
      var ENTER_KEY = 13;
      if (e.which === ENTER_KEY) {
        schedule.eventHandlers.submitAddNewVideoForm.call(this, e, schedule);
      }
    });

    $('#newModuleName').keyup(function(e) {
      var ENTER_KEY = 13;
      if (e.which === ENTER_KEY) {
        $('#addModuleButton').trigger('click');
      }
    });

    $('#submitActivityButton').click(function(e) {
      schedule.eventHandlers.showAddNewActivityModal.call(this, e, schedule);
    });

    $('#submitContentButton').click(function(e) {
      schedule.eventHandlers.showAddNewContentModal.call(this, e, schedule);
    });

    $('#editor-form').keypress(function(e) {
      if (e.which == 13) {
        return false;
      }
    });

    $('#trashCan').click(function(e) {
      schedule.refreshTrash();
      $('#trashContentModal').modal('show');
    });

    $('#trashContentModal').on('click', '.removeFromTrash', function(e) {
      var $item = $(this).closest('tr');

      schedule.move($item, schedule.$unassignedContentArea);

      for (var i = schedule.deletedContent.length - 1; i >= 0; i--) {
        if (schedule.deletedContent[i].path == $item.attr('data-path')) {
          schedule.deletedContent.splice(i, 1);
        }
      }

      $item.remove();

      schedule.refreshTrash();
    });

    $('#trashCan').droppable({
      accept:
        '#pageAccordionList li, #videoAccordionList li, #mediaAccordionList li, #activityAccordionList li',
      drop: function(event, ui) {
        $('#trashCan').removeClass('highlight');
        schedule.deleteItem(ui.helper);
        schedule.refreshSidebar();
        schedule.removeAllDroppableHighlights();
      },
      tolerance: 'pointer',
      over: function(event, ui) {
        $(event.target).addClass('highlight');
        ui.helper.addClass('hoverDrop');
      },
      out: function(event, ui) {
        $(event.target).removeClass('highlight');
        ui.helper.removeClass('hoverDrop');
      },
    });

    $('#rearrangeModules').click(function() {
      var moveList = [];
      var $rearrangeModulesModal = $('#rearrangeModulesModal');
      var $rearrangeModulesArea = $('#rearrangeModulesArea');
      $rearrangeModulesArea.empty();

      var $moduleListClone = schedule.$moduleList.clone();
      $moduleListClone
        .attr('id', 'moduleListClone')
        .addClass('rearrangeModules');
      $moduleListClone.find('.moduleDetails, .moduleDateRange').remove();
      $moduleListClone
        .sortable({
          axis: 'y',
          scroll: false,
        })
        .on('sortupdate', function(event, ui) {
          var uiID = parseInt(ui.item.attr('data-ui-id'));
          var movedPosition = ui.item.index();
          moveList.push({
            uiID: uiID,
            position: movedPosition,
          });
          $('#rearrangeModulesModal').data('moveList', moveList);
          // schedule.moveModule(uiID, movedPosition);
          // schedule.updateSubmissionForm();
        });

      $moduleListClone.appendTo($rearrangeModulesArea);

      $rearrangeModulesModal.modal('show');
    });

    $('.addRemoveModules').click(function() {
      var $addRemoveModulesModal = $('#addRemoveModulesModal');

      $addRemoveModulesModal.data('addRemoveData', {
        add: [], // list of titles to add
        remove: [], // list of uiids to remove
      });
      var $addRemoveModulesArea = $('#addRemoveModulesArea');
      $addRemoveModulesArea.empty();

      var $moduleListClone = schedule.$moduleList.clone();
      $moduleListClone
        .attr('id', 'moduleListClone')
        .addClass('addRemoveModules');
      $moduleListClone.find('.moduleDetails, .moduleDateRange').remove();
      $moduleListClone.find('.moduleTitle').each(function() {
        var $removeModuleButton = $(
          '<a class="removeModuleButton btn btn-danger btn-small">Remove Module</a>'
        );
        $(this).prepend($removeModuleButton);
      });
      $moduleListClone.appendTo($addRemoveModulesArea);

      var $moduleListClone = $('#moduleListClone');
      if ($moduleListClone.find('li').length != 0) {
        if (!$moduleListClone.hasClass('populated')) {
          $moduleListClone.addClass('populated');
        }
      } else {
        $moduleListClone.removeClass('populated');
      }

      $addRemoveModulesModal.modal('show').on('shown', function() {
        $('#newModuleName').focus();
      });
    });

    $('#addModuleButton').click(function() {
      var $addRemoveModulesModal = $('#addRemoveModulesModal');
      var $newModuleName = $('#newModuleName');
      var newModuleName = $.trim($newModuleName.val());
      if (newModuleName === '') {
        alert('Please specify a valid module name.');
      } else {
        var addRemoveData = $addRemoveModulesModal.data('addRemoveData');
        addRemoveData.add.push(newModuleName);

        var $newModulePreview = $(
          '<li class="module"><div class="moduleTitle"><a class="removeModuleButton btn btn-danger btn-small">Remove Module</a><h6><span class="newModuleName">' +
            newModuleName +
            '</span> <span class="newModuleStar">NEW</span></h6></div></li>'
        );
        var $moduleListClone = $('#moduleListClone');
        $moduleListClone.append($newModulePreview);

        $newModuleName.val('');
        if ($moduleListClone.find('li').length != 0) {
          if (!$moduleListClone.hasClass('populated')) {
            $moduleListClone.addClass('populated');
          }
        } else {
          $moduleListClone.removeClass('populated');
        }
      }
    });

    $('#addRemoveModulesModal').on('click', '.removeModuleButton', function() {
      var $this = $(this);
      var addRemoveData = $('#addRemoveModulesModal').data('addRemoveData');

      var uiID = $this.closest('.module').attr('data-ui-id');
      if (uiID != undefined) {
        var index = $.inArray(parseInt(uiID), addRemoveData.remove);
        if (index !== -1) {
          $this
            .closest('.module')
            .find('.moduleTitle h6 .removeModuleStar')
            .remove();
          addRemoveData.remove.splice(index, 1);
          $this.html('Remove Module');
        } else {
          $this
            .closest('.module')
            .find('.moduleTitle h6')
            .append(' <span class="removeModuleStar">REMOVE</span>');
          addRemoveData.remove.push(parseInt(uiID));
          $this.html('Unremove Module');
        }
      } else {
        var newModuleName = $this
          .closest('.module')
          .find('.newModuleName')
          .text();
        addRemoveData.add.splice(
          $.inArray(newModuleName, addRemoveData.add),
          1
        );
        $this.closest('.module').remove();
      }

      var $moduleListClone = $('#moduleListClone');
      if ($moduleListClone.find('li').length != 0) {
        if (!$moduleListClone.hasClass('populated')) {
          $moduleListClone.addClass('populated');
        }
      } else {
        $moduleListClone.removeClass('populated');
      }
    });

    $('#saveAddRemoveModules').click(function() {
      var $this = $(this);
      $this.attr('disabled', 'disabled');
      var addRemoveData = $('#addRemoveModulesModal').data('addRemoveData');

      if (addRemoveData.add.length || addRemoveData.remove.length) {
        if (addRemoveData.add.length) {
          for (var i = 0, len = addRemoveData.add.length; i < len; i++) {
            var moduleJSON = {
              uiID: schedule.getNextUIID(),
              title: addRemoveData.add[i],
              path: '',
              url: '',
              startDate: '',
              endDate: '',
              content: [],
              summary: '',
              activityCategories: [
                {
                  title: schedule.getCoreActivitiesTitle(),
                  affectsProgress: true,
                  activities: [],
                },
                {
                  title: schedule.getExtraActivitiesTitle(),
                  affectsProgress: false,
                  activities: [],
                },
              ],
            };
            var newModule = new ScheduleModule(moduleJSON);
            schedule.modules.push(newModule);
          }
        }

        if (addRemoveData.remove.length) {
          for (var i = 0, len = addRemoveData.remove.length; i < len; i++) {
            schedule.removeByUIID(addRemoveData.remove[i]);
          }
        }

        schedule.render();
        schedule.updateSubmissionForm();
      }

      $this.removeAttr('disabled');
      $('#addRemoveModulesModal').modal('hide');
    });

    $('#saveRearrangeModules').click(function() {
      var moveList = $('#rearrangeModulesModal').data('moveList');
      if (moveList && moveList.length) {
        for (var i = 0, len = moveList.length; i < len; i++) {
          schedule.moveModule(moveList[i].uiID, moveList[i].position);
        }
        schedule.render();
        schedule.updateSubmissionForm();
      }
      $('#rearrangeModulesModal').modal('hide');
    });

    $('#resetSchedule').click(function() {
      if (
        confirm(
          'This will discard any changes you have made. Are you sure you want to reset the schedule?'
        )
      ) {
        schedule.fromJSON(schedule.initialJSON);
        schedule.render();
        schedule.clearSubmissionForm();
      }
    });

    $('#submitModuleTitle').click(function() {
      var moduleUIID = parseInt($('#oldModuleUIID').val());
      var newModuleTitle = $.trim($('#newModuleTitle').val());

      if (newModuleTitle == '') {
        alert('You must specify a module title.');
      } else {
        var data = schedule.getByUIID(moduleUIID);
        data.ref.title = newModuleTitle;

        $('#moduleTitleModal').modal('hide');

        schedule.render();
        schedule.updateSubmissionForm();
      }
    });

    $('#newModuleTitle').keyup(function(e) {
      var ENTER_KEY = 13;
      if (e.which == ENTER_KEY) {
        $('#submitModuleTitle').trigger('click');
      }
    });

    // Holy hacks batman!
    // The whole tab is encapsulated inside a form and we can't nest forms.
    // Need to use a modal :(
    dust.render('mediaUpload', {}, function(error, html) {
      var $uploadMediaModal = $(html);

      var $form = $uploadMediaModal.find('form');
      $('body').append($uploadMediaModal);
      $form.fileupload({
        url:
          schedule.constants.SITE_URL +
          '/api/courses/' +
          schedule.constants.COURSE_PATH +
          '/UploadMedia/',
        dataType: 'json',
        fileInput: null,
      });

      $('#uploadMediaButton').click(function() {
        $('#uploadMediaFile').val('');
        $('#uploadMediaTable input[type=text]').val('');
        $('#uploadMediaModal').modal('show');
      });

      $('#submitUploadMedia').click(function() {
        var $this = $(this);
        $this.attr('disabled', 'disabled');
        var $form = $('#uploadMediaForm');
        if ($form.find('input[type=file]').val()) {
          $form.fileupload('add', {
            fileInput: $form.find('input[type=file]'),
            success: function(res) {
              if (res.success) {
                res.createdPage.uiID = schedule.getNextUIID();
                schedule.unassignedContent.push(res.createdPage);
                schedule.render();
                $('#uploadMediaModal').modal('hide');
                $('#addMediaButton').trigger('click');
              }
            },
            error: function(res) {
              alert('Media upload failed.');
            },
            complete: function() {
              $this.removeAttr('disabled');
            },
          });
        }
      });
    });

    $('#removeDates').click(function() {
      if (confirm('Are you sure you want to remove all dates?')) {
        var $this = $(this);
        $this.attr('disabled', 'disabled');

        var handleError = function() {
          alert('There was an error with the operation.');
        };

        // might break cross-domain? check
        $.ajax({
          url:
            '/cohorts/admin/?course=' +
            schedule.constants.COURSE_PATH +
            '&cohort=' +
            schedule.constants.COHORT_PATH +
            '&action=timeline',
          type: 'post',
          data: {
            actionType: 'removeCohortDates',
          },
          success: function(res) {
            window.location.reload();
          },
          error: handleError,
          complete: function() {
            $this.removeAttr('disabled');
          },
        });
      }
    });
    $('#recalculateDates').click(function() {
      if (
        confirm(
          'This will recalculate all dates based off the start date and throwaway any date overrides that exist. Are you sure you want to proceed?'
        )
      ) {
        var $this = $(this);
        $this.attr('disabled', 'disabled');

        var handleError = function() {
          alert('There was an error with the operation.');
        };

        $.ajax({
          url:
            '/cohorts/admin/?course=' +
            schedule.constants.COURSE_PATH +
            '&cohort=' +
            schedule.constants.COHORT_PATH +
            '&action=timeline',
          type: 'post',
          data: {
            actionType: 'recalculateDates',
            cohortStartDate: schedule.startDate,
          },
          success: function(res) {
            window.location.reload();
          },
          error: handleError,
          complete: function() {
            $this.removeAttr('disabled');
          },
        });
      }
    });

    $('#submitCohortDateSettings').click(function() {
      var $this = $(this);
      $this.attr('disabled', 'disabled');

      var cohortStartDate = schedule.$cohortStartDate.attr('data-value');

      var handleError = function() {
        alert('There was an error with the operation.');
      };

      var setCohortStartDate = true;
      if (setCohortStartDate) {
        $.ajax({
          url:
            '/cohorts/admin/?course=' +
            schedule.constants.COURSE_PATH +
            '&cohort=' +
            schedule.constants.COHORT_PATH +
            '&action=timeline',
          type: 'post',
          data: {
            actionType: 'setCohortStartDate',
            cohortStartDate: cohortStartDate,
          },
          success: function(res) {
            window.location.reload();
          },
          error: handleError,
          complete: function() {
            $this.removeAttr('disabled');
          },
        });
      }
    });

    $('#cohortDateSettingsButton, #setCohortStartDate').click(function() {
      $('#cohortDateSettingsModal').modal('show');
    });

    $('#activityCategoriesButton').click(function() {
      var coreActivitiesTitle = schedule.getCoreActivitiesTitle();
      var extraActivitiesTitle = schedule.getExtraActivitiesTitle();

      $('#coreActivityCategory').val(coreActivitiesTitle);
      $('#extraActivityCategory').val(extraActivitiesTitle);

      $('#activityCategoriesModal').modal('show');
    });

    $('#saveActivityCategories').click(function() {
      var coreActivitiesTitle = $.trim($('#coreActivityCategory').val());
      var extraActivitiesTitle = $.trim($('#extraActivityCategory').val());

      if (coreActivitiesTitle === '' || extraActivitiesTitle === '') {
        alert('Category Names can not be blank.');
      } else {
        schedule.setCoreActivitiesTitle(coreActivitiesTitle);
        schedule.setExtraActivitiesTitle(extraActivitiesTitle);
        schedule.render();
        schedule.updateSubmissionForm();
        $('#activityCategoriesModal').modal('hide');
      }
    });

    $('#modalMediaFileUploadInput').change(function(e) {
      var fileData = e.originalEvent.fpfile;
      var filename = fileData.filename;
      var filenameFormatted =
        filename.length > 60
          ? filename.substr(0, 54) +
            '...[' +
            filename.substr(filename.lastIndexOf('.')) +
            ']'
          : filename;
      var fileSize = Utilities.size_format(fileData.size);
      var fileDataText = fileData.size
        ? filenameFormatted + ' (' + fileSize + ')'
        : filenameFormatted;
      $('#currentMediaFileUploaded').text(fileDataText);
      $(this)
        .siblings('button')
        .text('Change File');
    });

    schedule.$window.on('schedulePresubmit', function(e) {
      if (schedule.state === schedule.states.SUMMARY_EDIT) {
        schedule.updateSubmissionForm();
      }

      $(window).off('beforeunload');
    });

    schedule.$window.on('message', function(e) {
      // this means we received a message from an inner iframe (page editor),
      // so we should update any visual differences from the updated page
      var dataJSON = e.originalEvent.data;
      var data;
      try {
        data = JSON.parse(dataJSON);
      } catch (err) {
        // we might have received a message not intended for us
        data = null;
      }

      // retrieve the new title
      if (data && data.HTMLData) {
        var newTitle = data.HTMLData.title;

        var editingPageLinkHtml = schedule.$pageEditorModal.data('page');
        var $pageListItem = $(editingPageLinkHtml).closest('li');
        var uiID = parseInt($pageListItem.attr('data-ui-id'));

        var dataReference = schedule.getByUIID(uiID).ref;
        var oldTitle = dataReference.title;
        if (newTitle !== oldTitle) {
          dataReference.title = newTitle;
          schedule.render();
          schedule.updateSubmissionForm();
        }
      }

      schedule.$pageEditorModal.modal('hide');
    });

    schedule.$pageEditorModal.on('hidden', function() {
      schedule.$pageEditorIFrame.attr('src', 'about:blank');
      schedule.$pageEditorLoadingMessage.show();
      schedule.$pageEditorPageLink.hide();
    });

    $('.highlightTopBar').hover(
      function() {
        schedule.$scheduleOptions.addClass('highlight');
        $(this).addClass('highlight');
      },
      function() {
        schedule.$scheduleOptions.removeClass('highlight');
        $(this).removeClass('highlight');
      }
    );

    $('.highlightRightBar').hover(
      function() {
        schedule.$unassignedContentArea.addClass('highlight');
        $(this).addClass('highlight');
      },
      function() {
        schedule.$unassignedContentArea.removeClass('highlight');
        $(this).removeClass('highlight');
      }
    );

    $('.accordion-body')
      .on('show', function() {
        $(this)
          .siblings('.addContentBox')
          .show(200, function() {
            schedule.fixScrollbar();
          });
      })
      .on('hide', function() {
        $(this)
          .siblings('.addContentBox')
          .hide(200, function() {
            schedule.fixScrollbar();
          });
      });

    $('#modalAddNewActivitySave').click(function() {
      var $this = $(this);
      $this.attr('disabled', 'disabled').button('saving');

      var successfulSave = false;

      var deferred = $.Deferred();

      var $inputField = $('.addNewActivityDetails input[name=activity]');
      var activityType = $('#activitySelectionInput').val();
      var appId = $('#activityAppInput').val();

      if (activityType == '') {
        deferred.reject();
        alert(
          'A type of activity needs to be selected, before an activity can be created.'
        );
      } else if ($.trim($inputField.val()) == '') {
        alert('An activity requires a title before it can be created.');
        $('#activity-title-input').addClass('invalid');
        deferred.reject();
      } else {
        var formData = {
          activity: $inputField.val(),
          submissionType: activityType,
          appId: appId,
        };

        API.post(
          'courses/' + schedule.constants.COURSE_PATH + '/Activities',
          formData
        )
          .done(function(res) {
            res.createdPage.uiID = schedule.getNextUIID();
            var moduleIndex = $('#addNewActivityModal').attr('data-module');
            if (moduleIndex !== undefined) {
              var activityCategoryIndex = $('#addNewActivityCategory').val();
              schedule.modules[moduleIndex].activityCategories[
                activityCategoryIndex
              ].activities.push(res.createdPage);
            } else {
              schedule.unassignedActivities.unshift(res.createdPage);
            }
            schedule.initialJSON.unassignedActivities.unshift(res.createdPage);
            schedule.render();
            deferred.resolve();
          })
          .fail(function(res) {
            alert(res);
            deferred.reject();
          });
      }

      deferred
        .done(function() {
          schedule.updateSubmissionForm();
          $('#addNewActivityModal').modal('hide');
          schedule.resetAddNewActivityModal();
        })
        .fail(function() {
          // fail silently because we already gave an error message.
        })
        .always(function() {
          $this.removeAttr('disabled').button('reset');
        });
    });

    $('#modalAddNewContentSave').click(function() {
      var $this = $(this);
      $this.attr('disabled', 'disabled').button('saving');

      // validate to ensure that we have good data
      var addContentType = $('#addNewContentType > li.highlight').attr(
        'data-id'
      );
      var successfulSave = false;

      var addContentItem = function(contentType, moduleIndex, res) {
        if (moduleIndex !== undefined) {
          schedule.modules[moduleIndex]['content'].push(res.createdPage);
        } else {
          schedule.unassignedContent.unshift(res.createdPage);
        }
      };

      var deferred = $.Deferred();
      switch (addContentType) {
        case 'page':
          var $inputField = $('.addNewContentDetails input[name=page]');
          if ($.trim($inputField.val()) == '') {
            alert('This content needs to have a title before it can be added.');
            $('#content-title-input').addClass('invalid');
            deferred.reject();
          } else {
            var formData = {
              page: $inputField.val(),
            };
            API.post(
              'courses/' + schedule.constants.COURSE_PATH + '/Pages',
              formData
            )
              .done(function(res) {
                res.createdPage.uiID = schedule.getNextUIID();
                var moduleIndex = $('#addNewContentModal').attr('data-module');

                addContentItem('content', moduleIndex, res);

                schedule.initialJSON.unassignedContent.unshift(res.createdPage);
                schedule.render();
                deferred.resolve();
              })
              .fail(function(res) {
                alert(res);
                deferred.reject();
              });
          }
          break;
        case 'file':
          var $inputField = $('.addNewContentDetails input[name=mediaTitle]');
          var $inputFileField = $(
            '.addNewContentDetails input[name=mediaFile]'
          );
          if ($.trim($inputField.val()) == '') {
            alert('A title needs to be specified before this can be added.');
            deferred.reject();
          } else if ($.trim($inputFileField.val()) == '') {
            alert('Please select a file to upload.');
            deferred.reject();
          } else {
            var formData = {
              name: $inputField.val(),
              mediaFileURL: $inputFileField.val(),
            };
            API.post(
              'courses/' + schedule.constants.COURSE_PATH + '/UploadMedia',
              formData
            )
              .done(function(res) {
                res.createdPage.uiID = schedule.getNextUIID();
                var moduleIndex = $('#addNewContentModal').attr('data-module');

                addContentItem('file', moduleIndex, res);

                schedule.initialJSON.unassignedContent.unshift(res.createdPage);
                schedule.render();
                deferred.resolve();
              })
              .fail(function(res) {
                alert(res);
                deferred.reject();
              });
          }
          break;
        case 'video':
          var $videoTitleField = $(
            '.addNewContentDetails input[name=videoTitle]'
          );
          var $videoURLField = $('.addNewContentDetails input[name=videoURL]');
          if ($.trim($videoTitleField.val()) == '') {
            alert(
              'A title needs to be added for this video before it can be added.'
            );
            deferred.reject();
          } else if ($.trim($videoURLField.val()) == '') {
            alert('Please type in a valid video URL.');
            deferred.reject();
          } else {
            var formData = {
              videoTitle: $videoTitleField.val(),
              videoURL: $videoURLField.val(),
            };
            API.post(
              'courses/' + schedule.constants.COURSE_PATH + '/Videos',
              formData
            )
              .done(function(res) {
                res.createdPage.uiID = schedule.getNextUIID();
                var moduleIndex = $('#addNewContentModal').attr('data-module');

                addContentItem('video', moduleIndex, res);

                schedule.initialJSON.unassignedContent.unshift(res.createdPage);
                schedule.render();
                deferred.resolve();
              })
              .fail(function(res) {
                alert(res);
                deferred.reject();
              });
          }
          break;
        default:
          deferred.reject();
          alert('Select the type of content you wish to add.');
          $('#select-content-label').addClass('invalid');
          $('#assistance-arrow')
            .show()
            .animate({ left: '50px' }, function() {
              $(this).animate({ left: '40px' });
            });
      }

      deferred
        .done(function() {
          schedule.updateSubmissionForm();
          $('#addNewContentModal').modal('hide');
          schedule.resetAddNewContentModal();
        })
        .fail(function() {
          // fail silently because we already gave an error message.
        })
        .always(function() {
          $this.removeAttr('disabled').button('reset');
        });
    });
  },
  resizeModals: function(e) {
    var schedule = e.data.schedule;

    // only the iframe modal needs to be resized...
    if (schedule.$pageEditorModal.attr('aria-hidden') !== 'true') {
      var windowHeight = schedule.$window.height();
      var modalBodyHeight = windowHeight * 0.75;
      schedule.$pageEditorModal
        .find('.modal-body')
        .stop()
        .animate({ height: modalBodyHeight + 'px' });
      $('#pageEditorIFrame').height(modalBodyHeight - 39);
    }
  },
  getCoreActivitiesTitle: function() {
    return this.coreActivitiesTitle || 'Activities';
  },
  getExtraActivitiesTitle: function() {
    return this.extraActivitiesTitle || 'Further Study';
  },
  setCoreActivitiesTitle: function(title) {
    var schedule = this;
    schedule.coreActivitiesTitle = title;

    for (var i = 0, len = schedule.modules.length; i < len; i++) {
      schedule.modules[i].activityCategories[0].title = title;
    }
  },
  setExtraActivitiesTitle: function(title) {
    var schedule = this;
    schedule.extraActivitiesTitle = title;

    for (var i = 0, len = schedule.modules.length; i < len; i++) {
      schedule.modules[i].activityCategories[1].title = title;
    }
  },
  refreshSidebar: function(e) {
    var INCLUDE_MARGIN = true;

    var headerBarHeight = $('header').outerHeight();
    var $editScheduleArea = $('#edit-schedule');
    var editScheduleTop = $editScheduleArea.offset().top;
    var editScheduleHeight = $editScheduleArea.outerHeight(INCLUDE_MARGIN);

    var $unassignedContentArea = $('#unassignedContentArea');
    var unassignedContentAreaHeight = $unassignedContentArea.outerHeight(
      INCLUDE_MARGIN
    );

    var $window = $(window);
    var TOP_MARGIN = 10;
    var trashCanHeight = 70;
    var windowScrollTop = $window.scrollTop();
    var unassignedContentHeadersHeight = 46 * 4; // The Activities (xx), Pages (xx) header
    var userBarHeight = 46;
    var topOptionsHeight = $('#scheduleOptions').outerHeight(INCLUDE_MARGIN);
    var $noCohortDatesMessage = $('#noCohortDatesMessage');
    if ($noCohortDatesMessage.is(':visible')) {
      topOptionsHeight += $noCohortDatesMessage.outerHeight(INCLUDE_MARGIN);
    }

    var activeAddContentBoxHeight = $(
      '#unassignedContentArea .accordion-body.in'
    )
      .siblings('.addContentBox')
      .outerHeight();
    $('#unassignedContentArea .accordion-inner').css(
      'max-height',
      $window.height() -
        headerBarHeight -
        userBarHeight -
        trashCanHeight -
        unassignedContentHeadersHeight -
        activeAddContentBoxHeight -
        20 +
        'px'
    );

    // always keep the same width
    var sidebarWidth = $unassignedContentArea[0].getBoundingClientRect().width;

    // will vary depending on width of screen
    var screenSize = getScreenSize();
    if (screenSize == 'mobile') {
      $unassignedContentArea
        .removeClass('fixed affixBottom')
        .addClass('affixTop')
        .css({ width: '' });
    } else {
      var leftOffset = determineLeftOffset();
      var shouldSnapToBottom =
        windowScrollTop +
          headerBarHeight +
          userBarHeight +
          unassignedContentAreaHeight +
          TOP_MARGIN >
        editScheduleTop + editScheduleHeight;
      var shouldAffix =
        windowScrollTop + headerBarHeight + userBarHeight + TOP_MARGIN >
        editScheduleTop + topOptionsHeight;
      if (shouldSnapToBottom) {
        var cssPositioning = {
          top:
            editScheduleHeight - topOptionsHeight - unassignedContentAreaHeight,
          left: 0,
          width: '',
        };
        $unassignedContentArea
          .removeClass('fixed affixTop')
          .addClass('affixBottom')
          .css(cssPositioning);
      } else if (shouldAffix) {
        var cssPositioning = {
          top: headerBarHeight + userBarHeight + TOP_MARGIN + 'px',
          left: leftOffset,
          width: sidebarWidth + 'px',
        };
        $unassignedContentArea
          .removeClass('affixTop affixBottom')
          .addClass('fixed')
          .css(cssPositioning);
      } else {
        $unassignedContentArea
          .removeClass('fixed affixBottom')
          .addClass('affixTop')
          .css({ width: '' });
      }
    }
  },
  highlightContentDroppables: function(ignoreUnassignedArea) {
    $('.moduleContentList').addClass('highlightDroppable');
    if (!ignoreUnassignedArea) {
      $('#unassignedContentArea').addClass('highlightDroppable');
    }
  },
  highlightActivityDroppables: function(ignoreUnassignedArea) {
    $('.moduleActivityList').addClass('highlightDroppable');
    if (!ignoreUnassignedArea) {
      $('#unassignedContentArea').addClass('highlightDroppable');
    }
  },
  highlightTrashCan: function() {
    $('#trashCan').addClass('highlightDroppable');
  },
  removeAllDroppableHighlights: function() {
    $('.highlightDroppable').removeClass('highlightDroppable');
  },
  hideElementsDuringDrag: function() {
    $('.moduleAddActivityButton, .moduleAddContentButton').addClass(
      'visibilityHidden'
    );
  },
  showElementsAfterDrag: function() {
    $('.moduleAddActivityButton, .moduleAddContentButton').removeClass(
      'visibilityHidden'
    );
  },
  updateDate: function(uiID, type, date) {
    var schedule = this;

    var isoDate, processedDate;
    if (date instanceof Date) {
      isoDate = date.toISOString();
      processedDate = Utilities.formatTimestamp(
        date,
        schedule.activityDateFormat
      );
    } else {
      return false;
    }

    var data = schedule.getByUIID(uiID);

    if (type == 'start') {
      $.extend(data.ref, {
        startDate: isoDate,
        startDateProcessed: processedDate,
      });
    } else if (type == 'end') {
      $.extend(data.ref, {
        endDate: isoDate,
        endDateProcessed: processedDate,
      });
    } else {
      return false;
    }

    return true;
  },
  setEventHandlers: function() {
    var schedule = this;

    $('.moduleContentList')
      .sortable({
        placeholder: 'ui-state-highlight',
        connectWith: '#contentArea, .moduleContentList',
        cursorAt: {
          left: 50,
        },
        dropOnEmpty: true,
        update: function(event, ui) {
          schedule.move(ui.item, $(this));
          schedule.removeAllDroppableHighlights();
        },
        helper: 'clone',
        scroll: false,
      })
      .on('sortstart', function(event, ui) {
        schedule.highlightContentDroppables();
      })
      .on('sortstop', function(event, ui) {
        schedule.removeAllDroppableHighlights();
      });

    $('.moduleActivityList')
      .sortable({
        placeholder: 'ui-state-highlight',
        connectWith: '#contentArea, .moduleActivityList',
        cursorAt: {
          left: 50,
        },
        dropOnEmpty: true,
        helper: 'clone',
        scroll: false,
      })
      .on('sortupdate', function(event, ui) {
        schedule.move(ui.item, $(this));
        schedule.removeAllDroppableHighlights();
      })
      .on('sortstart', function(event, ui) {
        schedule.highlightActivityDroppables();
      })
      .on('sortstop', function(event, ui) {
        schedule.removeAllDroppableHighlights();
      });

    $('#unassignedContentArea').droppable({
      accept: '.moduleContentList li, .moduleActivityList li',
      drop: function(event, ui) {
        schedule.move(ui.helper, $(this));
        schedule.refreshSidebar();
        schedule.removeAllDroppableHighlights();

        //console && console.log('breaks after here', $(ui.helper).data());
      },
      tolerance: 'pointer',

      // These should be achieved by hoverDrop, but it isn't working
      over: function(event, ui) {
        ui.helper.addClass('hoverDrop');
      },
      out: function(event, ui) {
        ui.helper.removeClass('hoverDrop');
      },
    });

    $('#pageAccordionList li, #videoAccordionList li, #mediaAccordionList li')
      .draggable({
        connectToSortable: '.moduleContentList',
        revert: 'invalid',
        revertDuration: 0,
        helper: function(e) {
          var $clone = $(e.currentTarget).clone();
          $clone.appendTo($('body')).addClass('hover');
          return $clone;
        },
        zIndex: 10000,
      })
      .on('dragstart', function(event, ui) {
        schedule.highlightContentDroppables(true);
        schedule.highlightTrashCan();
        schedule.hideElementsDuringDrag();
        $(event.currentTarget).hide();
      })
      .on('dragstop', function(event, ui) {
        $(event.currentTarget).show();
        schedule.removeAllDroppableHighlights();
        schedule.showElementsAfterDrag();
      });

    $('#activityAccordionList li')
      .draggable({
        connectToSortable: '.moduleActivityList',
        revert: 'invalid',
        revertDuration: 0,
        helper: function(e) {
          var $clone = $(e.currentTarget).clone();
          $clone.appendTo($('body')).addClass('hover');
          return $clone;
        },
        zIndex: 10000,
      })
      .on('dragstart', function(event, ui) {
        $(event.currentTarget).hide();
        schedule.highlightActivityDroppables(true);
        schedule.highlightTrashCan();
        schedule.hideElementsDuringDrag();
      })
      .on('dragstop', function(event, ui) {
        $(event.currentTarget).show();
        schedule.removeAllDroppableHighlights();
        schedule.showElementsAfterDrag();
      });

    $(
      '.activityStartDate, .activityEndDate, .moduleStartDate, .moduleEndDate'
    ).focus(function() {
      $(this).blur();
    });

    $('.activityStartDate, .activityEndDate')
      .datetimepicker()
      .on('changeDate hide', function(e) {
        var $input = $(e.currentTarget);
        $input.val(
          Utilities.formatTimestamp(e.date, schedule.activityDateFormat)
        );
        $input.attr('data-value', e.date.toISOString());

        var uiID = $input.closest('li').attr('data-ui-id');

        var type = 'start';
        if ($input.hasClass('activityEndDate')) {
          type = 'end';
        }
        schedule.updateDate(uiID, type, e.date);
        schedule.updateSubmissionForm();
      });

    $('.moduleStartDate, .moduleEndDate')
      .datetimepicker()
      .on('changeDate hide', function(e) {
        var $input = $(e.currentTarget);
        $input.val(
          Utilities.formatTimestamp(e.date, schedule.activityDateFormat)
        );
        $input.attr('data-value', e.date.toISOString());

        var uiID = $input.closest('li').attr('data-ui-id');

        var type = 'start';
        if ($input.hasClass('moduleEndDate')) {
          type = 'end';
        }
        schedule.updateDate(uiID, type, e.date);
        schedule.updateSubmissionForm();
      });

    $('.moduleSummary').each(function() {
      var summary = this;
      var modulePath = $(this)
        .closest('.module')
        .attr('data-path');
      var editor = CKEDITOR.inline(
        this,
        $.extend({}, schedule.ckeditorOptions, { path: modulePath })
      );

      editor.on(
        'focus',
        function(e) {
          schedule.changeState(schedule.states.SUMMARY_EDIT);
          var summary = e.listenerData.summary;
          var $summary = $(summary);
          if ($summary.attr('data-empty') == '1') {
            $summary.html('');
          }
        },
        null,
        { summary: summary }
      );

      // known bug: if the user goes from editing straight to
      // dragging and dropping without manually blurring first,
      // then the drag/drop event handler kicks in before this blur
      // and the changes will be lost. FIXME: above
      editor.on(
        'blur',
        function(e) {
          schedule.changeState(schedule.states.NORMAL);
          var summary = e.listenerData.summary;
          var $summary = $(summary);
          var htmlText = $.trim($summary.text());

          // update the schedule
          var $module = $summary.closest('li.module');
          var moduleUIID = parseInt($module.attr('data-ui-id'));
          var moduleData = schedule.getByUIID(moduleUIID);

          // should be safe to do this / could potentially cause/inject
          // scripts into their own page, but not save it. revise this
          // if we ever save backups. FIXME: above
          moduleData.ref.summary = $summary.html();

          // if something was typed and backspaced again, it resolves to a <br>
          if (htmlText == '') {
            $summary.html(schedule.emptySummaryText);
            $summary.attr('data-empty', '1');
          } else {
            $summary.attr('data-empty', '0');
          }

          schedule.updateSubmissionForm();
        },
        null,
        { summary: summary }
      );
    });

    $('.moduleTitleButton').click(function() {
      var $this = $(this);
      var oldModuleTitle = $this.closest('.module').attr('data-title');
      var moduleURL = $this.closest('.module').attr('data-url');
      var oldModulePath = $this.closest('.module').attr('data-path');
      var oldModuleUIID = $this.closest('.module').attr('data-ui-id');

      // Load modal data before we show.
      $('#oldModuleUIID').val(oldModuleUIID);
      $('#oldModuleTitle').val(oldModuleTitle);
      $('#oldModulePath').val(oldModulePath);
      $('#moduleTitleLink').attr('href', moduleURL);
      $('#newModuleTitle').removeAttr('value');

      $('#moduleTitleModal')
        .modal('show')
        .on('shown', function() {
          $('#newModuleTitle').focus();
        });
    });

    $('.moduleActivityTitle').click(function() {
      $('#activityCategoriesButton').trigger('click');
    });

    $('.moduleAddContentButton').click(function(e) {
      schedule.eventHandlers.showAddNewContentModal.call(this, e, schedule);
    });

    $('.moduleAddActivityButton').click(function(e) {
      schedule.eventHandlers.showAddNewActivityModal.call(this, e, schedule);
    });

    $('#addNewContentType li').click(function() {
      var $this = $(this);
      $('#modalAddNewContentSave').show();

      $('#addNewContentType li').removeClass('highlight');
      $this.addClass('highlight');

      $('.addNewContentDetails').hide();
      $(
        '.addNewContentDetails[data-id="' + $this.attr('data-id') + '"]'
      ).show();
    });

    // Handle the embedding of edit pages inside modals
    $('.pageEditLink').click(function(e) {
      e.preventDefault();

      var url = $(this).attr('href');

      // A special version of the page which strips sections out.
      var hiddenElementUrl = Utilities.updateQueryStringParameter(
        url,
        'embeddedEdit',
        '1'
      );
      schedule.$pageEditorIFrame.attr('src', hiddenElementUrl);

      // do some css styling on the iframe contents
      schedule.$pageEditorIFrame.load(function() {
        if (
          schedule.$pageEditorIFrame.attr('src').indexOf('about:blank') === -1
        ) {
          schedule.$pageEditorPageLink.attr('href', url).show();
          schedule.$pageEditorLoadingMessage.hide();
          schedule.$pageEditorIFrame
            .contents()
            .find('#page-container')
            .css('padding', 0);
        }
      });

      schedule.$pageEditorModal.data('page', this);
      schedule.$pageEditorModal
        .modal('show')
        .on(
          'shown',
          $.proxy(schedule.resizeModals, this, { data: { schedule: schedule } })
        );
    });

    $('input.progress-toggle').change(function(e) {
      var $this = $(this);
      var $listItem = $this.closest('li');
      var affectsProgress = $this.is(':checked');
      var uiID = parseInt($listItem.attr('data-ui-id'));
      $listItem.attr('data-affects-progress', affectsProgress);
      schedule.getByUIID(uiID).ref.affectsProgress = affectsProgress;
      schedule.updateSubmissionForm();
    });
  },
});
